import { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { oktaEnabled, oktaDisabledFakeUserInfo } from '../config';
import { UserProvider } from '../context/UserContext';

const AuthUserProvider = ({ children }) => {
	const { oktaAuth, authState } = useOktaAuth();
	const [userInfo, setUserInfo] = useState(oktaEnabled?null:oktaDisabledFakeUserInfo);

	useEffect(() => {
		const getUser = async () => {
			try {
				const res = await oktaAuth.getUser();
				setUserInfo(res);
			} catch (error) {
				console.error(error);
			}
		};

		if (oktaEnabled && authState?.isAuthenticated) {
			getUser();
		}
	}, [authState, oktaAuth]);

	return (
		<UserProvider value={userInfo}>
			{children}
		</UserProvider>
	);
};

export default AuthUserProvider;